import { connect } from "react-redux";
import { quiz2MetaWatch } from "../../actions/quiz2Actions";
import WatchMeta from "../quiz/WatchMeta";

const mapStateToProps = state => ({
  quizN: state.quiz2
});

export default connect(
  mapStateToProps,
  { quizNMetaWatch: quiz2MetaWatch }
)(WatchMeta);
